import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IndentForm } from "@/features/indents/IndentForm";
import { useIndent } from "@/features/indents/api";

export const Route = createFileRoute("/_authenticated/indents/$indentId/edit")({
  component: EditIndentPage,
});

function EditIndentPage() {
  const navigate = useNavigate();
  const { indentId } = Route.useParams();
  const { data: indent, isLoading } = useIndent(indentId);

  if (isLoading) return <div className="grid place-items-center p-10"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  if (!indent) return <div className="p-6 text-sm text-muted-foreground">Indent not found.</div>;
  if (indent.status !== "Draft") return <div className="p-6 text-sm text-muted-foreground">Only Draft indents can be edited.</div>;

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/indents" })}><ArrowLeft className="mr-1 h-4 w-4" />Back</Button>
      <IndentForm initialData={indent} />
    </div>
  );
}
